import React from "react";
import { CreateFormsProps } from "../pages/Requests/CreateRequestPage";
import { FormTypeEnum } from "../api";
import FormView from "../pages/Requests/FormViewPage";
import AssessmentFormComponent from "../pages/Assessment/AssessmentFormComponent";
import LinkedObjectFormComponent from "../pages/LinkedObject/LinkedObjectFormComponent";
import CommentComponent from "./CommentComponent";

interface Props {
  form: CreateFormsProps;
  requestId?: number;
  onSuccess: (result: any) => void;
  readonly?: boolean;
  values?: any;
  duplicateRequestId?: number | undefined;
  setDuplicateRequestId?: (duplicateRequestId: number | undefined) => void;
  // In STEP (wizard) mode the parent asks each step to render the "Previous"
  // button inline with its own Save, so both sit on one row. Left unset in
  // COLLAPSE mode, where there is no step-to-step navigation.
  showPrev?: boolean;
  onPrev?: () => void;
  // View page: a section owner gets a "Submit" button next to Save (saves then
  // marks the section done).
  onSubmitSection?: () => Promise<void>;
  submitLabel?: string;
}

const RenderFormComponent = ({
  form,
  requestId,
  onSuccess,
  readonly,
  duplicateRequestId,
  setDuplicateRequestId,
  showPrev,
  onPrev,
  onSubmitSection,
  submitLabel,
}: Props) => {
  const renderForm = (type: FormTypeEnum) => {
    console.log(type);
    switch (type) {
      case FormTypeEnum.DYNAMIC:
        return (
          <FormView
            schema={form.schema}
            formProps={form.form}
            formId={form.form_id}
            requestId={requestId}
            readonly={readonly}
            onSuccess={onSuccess}
            duplicateRequestId={duplicateRequestId}
            setDuplicateRequestId={setDuplicateRequestId}
            system_form_extra_actions={form.system_form_extra_actions}
            showPrev={showPrev}
            onPrev={onPrev}
            onSubmitSection={onSubmitSection}
            submitLabel={submitLabel}
          />
        );
      case FormTypeEnum.RISK_ASSESSMENT:
        return (
          <AssessmentFormComponent
            schema={form.schema}
            formProps={form.form}
            formId={form.form_id}
            requestId={requestId}
            readonly={readonly}
            onSuccess={onSuccess}
            duplicateRequestId={duplicateRequestId}
            setDuplicateRequestId={setDuplicateRequestId}
            showPrev={showPrev}
            onPrev={onPrev}
            onSubmitSection={onSubmitSection}
            submitLabel={submitLabel}
          />
        );
      case FormTypeEnum.LINKED_OBJECT:
        return (
          <LinkedObjectFormComponent
            schema={form.schema}
            formProps={form.form}
            formId={form.form_id}
            requestId={requestId}
            readonly={readonly}
            onSuccess={onSuccess}
            duplicateRequestId={duplicateRequestId}
            setDuplicateRequestId={setDuplicateRequestId}
            showPrev={showPrev}
            onPrev={onPrev}
          />
        );
      case FormTypeEnum.COMMENT:
        return (
          <CommentComponent
            schema={form.schema}
            formProps={form.form}
            formId={form.form_id}
            requestId={requestId}
            readonly={readonly}
            onSuccess={onSuccess}
            duplicateRequestId={duplicateRequestId}
            setDuplicateRequestId={setDuplicateRequestId}
            showPrev={showPrev}
            onPrev={onPrev}
          />
        );
      default:
        return null;
    }
  };

  return <>{renderForm(form.formType!)}</>;
};

export default RenderFormComponent;
